import React, { createContext, useContext, useState } from 'react';

const ModalContext = createContext();

export const useModal = () => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error('useModal must be used within a ModalProvider');
  }
  return context;
};

export const ModalProvider = ({ children }) => {
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const [isSignupOpen, setIsSignupOpen] = useState(false);
  const [isTermsOpen, setIsTermsOpen] = useState(false);
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
  const [signupData, setSignupData] = useState(null);

  const openLogin = () => {
    setIsLoginOpen(true);
    setIsSignupOpen(false);
  };

  const openSignup = (data = null) => {
    // Ensure we only set signupData if it's actually data, not a click event
    const isEvent = data && (data.nativeEvent || data.target);
    setSignupData(isEvent ? null : data);
    setIsSignupOpen(true);
    setIsLoginOpen(false);
  };

  const closeModals = () => {
    setIsLoginOpen(false);
    setIsSignupOpen(false);
    setIsTermsOpen(false);
    setIsPrivacyOpen(false);
    setSignupData(null);
  };

  const switchToSignup = (data = null) => {
    // Ensure we only set signupData if it's actually data, not a click event
    const isEvent = data && (data.nativeEvent || data.target);
    setSignupData(isEvent ? null : data);
    setIsLoginOpen(false);
    setIsSignupOpen(true);
  };

  const switchToLogin = () => {
    setIsSignupOpen(false);
    setIsLoginOpen(true);
  };

  const openTerms = () => {
    setIsTermsOpen(true);
    setIsPrivacyOpen(false);
  };

  const openPrivacy = () => {
    setIsPrivacyOpen(true);
    setIsTermsOpen(false);
  };

  return (
    <ModalContext.Provider value={{
      isLoginOpen,
      isSignupOpen,
      isTermsOpen,
      isPrivacyOpen,
      signupData,
      openLogin,
      openSignup,
      openTerms,
      openPrivacy,
      closeModals,
      switchToSignup,
      switchToLogin
    }}>
      {children}
    </ModalContext.Provider>
  );
};